import React from 'react';
import {StyleSheet, View} from 'react-native';

import {getSkeletonColors, STAGGER} from '../constants';
import {BoneImage} from '../primitives/BoneImage';
import {BoneStepper} from '../primitives/BoneStepper';
import {BoneText} from '../primitives/BoneText';

/**
 * Skeleton for cart line items.
 * Mirrors: CartLineItemLoyaltyEnabled layout
 * Reference: app/screens/cart/components/CartLineItem/CartLineItemLoyaltyEnabled.tsx
 *   styles.item, styles.itemInside, styles.leftCol (flex:1), styles.rightCol (flex:3)
 */
export const CartItemSkeleton: React.FC = React.memo(() => (
  <View style={styles.item}>
    <View style={styles.itemInside}>
      <View style={styles.leftCol}>
        <BoneImage variant="thumbnail" animationDelay={STAGGER.delay(0)} />
      </View>
      <View style={styles.rightCol}>
        <BoneText variant="h1" width="70%" animationDelay={STAGGER.delay(1)} />
        <BoneText variant="body" width="35%" animationDelay={STAGGER.delay(2)} />
        <BoneText variant="price" width="40%" animationDelay={STAGGER.delay(3)} />
        <BoneText variant="caption" width="30%" animationDelay={STAGGER.delay(4)} />
        <View style={styles.bottomRow}>
          <BoneText variant="body" width="50%" animationDelay={STAGGER.delay(5)} />
          <BoneStepper animationDelay={STAGGER.delay(6)} />
        </View>
      </View>
    </View>
  </View>
));

CartItemSkeleton.displayName = 'CartItemSkeleton';

const styles = StyleSheet.create({
  item: {
    borderWidth: 0.5,
    borderColor: getSkeletonColors().border,
    borderRadius: 4,
    paddingLeft: 4,
    backgroundColor: getSkeletonColors().cardBackground,
    marginBottom: 6,
  },
  itemInside: {
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    paddingHorizontal: 4,
    paddingVertical: 2,
  },
  leftCol: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  rightCol: {
    flex: 3,
    flexDirection: 'column',
    paddingHorizontal: 4,
    paddingVertical: 2,
    gap: 4,
  },
  bottomRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 4,
  },
});
